
import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { formatDateWithFallback } from '@/utils/dateUtils';

interface GoCampaignStatusCardProps { 
  status: string;
  updatedAt?: string;
  className?: string;
}

const GoCampaignStatusCard: React.FC<GoCampaignStatusCardProps> = ({ 
  status, 
  updatedAt,
  className = ""
}) => {
  return (
    <Card className={cn(`bg-white border border-gray-200 flex flex-col`, className)}>
      <CardHeader className="pb-1 pt-2 px-2 text-left">
        <h3 className="text-xs font-medium text-muted-foreground">GoCampaign Status</h3>
      </CardHeader>
      <CardContent className="px-2 pb-2 pt-0 text-left">
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <p className="font-semibold text-sm break-words capitalize mr-1">
              {status || 'Onboarding'}
            </p>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <button className="inline-flex items-center">
                    <Info size={12} className="text-muted-foreground" />
                  </button>
                </TooltipTrigger>
                <TooltipContent className="text-xs">
                  Last Updated: {formatDateWithFallback(updatedAt, 'Today')}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default GoCampaignStatusCard;
